import { render, staticRenderFns } from "./LenonFileButton.vue?vue&type=template&id=76c5988e&scoped=true&"
import script from "./LenonFileButton.vue?vue&type=script&lang=js&"
export * from "./LenonFileButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c5988e",
  null
  
)

export default component.exports